<template>
  <tr class="orders-details">
    <td colspan="8">
      <transition
        mode="out-in"
        name="fade"
      >
        <Loader
          v-if="bidsLoader"
          class="my-5 py-5"
        />
        <table
          v-else
        >
          <Alerts />
          <LastOrder
            v-if="auction.lastOrder"
            :auction="auction"
          />
          <BidsTable
            v-if="auction.bids"
            :auction="auction"
          />
          <h3
            v-if="emptyDetails"
            class="text-center my-5"
          >
            {{ I18n.t("employees.auctions_catalogs.internet_orders.no_offers") }}
          </h3>
        </table>
      </transition>
    </td>
  </tr>
</template>

<script>
  import { mapState, mapGetters } from 'vuex';
  import Loader from '@/shared/components/loader';
  import Alerts from './alerts';
  import LastOrder from './last_order';
  import BidsTable from './../table/bids_table';

  export default {
    name: 'OrdersDetails',
    components: {
      Loader,
      Alerts,
      LastOrder,
      BidsTable,
    },
    props: {
      auction: {
        type: Object,
        required: true,
      },
    },
    computed: {
      ...mapState(['bidsLoader']),
      ...mapGetters(['bidsCount']),
      emptyDetails() {
        return !this.auction.lastOrder && !this.auction.bids && !this.bidsCount;
      },
    },
    mounted() {
      this.$scrollTo(`#auction_${this.auction.id}`);
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/employees_orders_panel/components/orders/orders_details.vue?5a89a6e6